import React from 'react';
import {
  At,
  Buildings,
  CalendarBlank,
  EnvelopeSimple,
  Globe,
  IdentificationCard,
  LockSimple,
  MapPin,
  Phone,
} from 'phosphor-react';

export const FIELD_ICON_SIZE = 14;

const MASK_ICONS: Record<string, JSX.Element> = {
  '(99) 99999-9999': <Phone size={FIELD_ICON_SIZE} />,
  '(99) 9999-9999': <Phone size={FIELD_ICON_SIZE} />,
  '999.999.999-99': <IdentificationCard size={FIELD_ICON_SIZE} />,
  '99.999.999/9999-99': <Buildings size={FIELD_ICON_SIZE} />,
  '99999-999': <MapPin size={FIELD_ICON_SIZE} />,
};

const NAME_ICONS: Array<[RegExp, JSX.Element]> = [
  [/(^|_)e?mail($|_)/i, <EnvelopeSimple size={FIELD_ICON_SIZE} />],
  [/password|senha/i, <LockSimple size={FIELD_ICON_SIZE} />],
  [/(cell_?phone|phone|telefone|celular)/i, <Phone size={FIELD_ICON_SIZE} />],
  [/(^|_)(site|url|link|website)($|_)/i, <Globe size={FIELD_ICON_SIZE} />],
  [/username|login/i, <At size={FIELD_ICON_SIZE} />],
  [/(birth|date|data)/i, <CalendarBlank size={FIELD_ICON_SIZE} />],
];

export const iconForMask = (mask?: string): JSX.Element | undefined =>
  mask ? MASK_ICONS[mask] : undefined;

export const iconForFieldName = (name?: string, type?: string): JSX.Element | undefined => {
  if (type === 'email') return <EnvelopeSimple size={FIELD_ICON_SIZE} />;
  if (type === 'password') return <LockSimple size={FIELD_ICON_SIZE} />;
  if (type === 'url') return <Globe size={FIELD_ICON_SIZE} />;
  if (!name) return undefined;
  const match = NAME_ICONS.find(([pattern]) => pattern.test(name));
  return match?.[1];
};
